import React from "react";
import { Icon } from "@fluentui/react";

interface IProps {
  icon: string;
}

export const ActionButtonIcon: React.FC<IProps> = props => {
  const { icon } = props;
  let iconName = "";
  switch (icon) {
    case "check":
      iconName = "CheckMark";
      break;
    case "phone":
      iconName = "Phone"; 
      break;
    case "user":
      iconName = "UserFollowed";
      break;
    case "close":
      iconName = "ChromeClose";
      break;
    case "redo":
      iconName = "SyncOccurence";
      break;
    case "stop":
      iconName = "Stop";
      break;
    case "pause":
      iconName = "Pause";
      break;
    case "flush":
      iconName = "Filter";
      break;
  }

  return <Icon iconName={iconName}></Icon>;
};
